import * as React from 'react';
import './index.css';

interface IBarGraphProps {
  items: any;
  selectItem: any;
  selectedItem: any;
}

class Wheel extends React.Component<IBarGraphProps, {}> {
    public myChart: any;

    constructor(props) {
      super(props);
    }

    public render() {
      const { items, selectedItem } = this.props;

      const mainOptions = items.filter(item => item.label !== "" && item.guid !== "");

      const wheelVars: any = {
        '--nb-item': mainOptions.length,
        '--selected-item': selectedItem,
      };
      const spinning = selectedItem !== null ? 'spinning' : '';

      return (
        <div className="wheel-container">
          <div className={`wheel ${spinning}`} style={wheelVars} onClick={this.props.selectItem}>
            {mainOptions.map((item, index) => 
            {
              const childDivStyle: any = { '--item-nb': index };
              return (
                <>
                {item.label && <div className="wheel-item" key={index} style={childDivStyle}>
                  {item.label}
                </div>}
                </>
              )
            }
            )}
          </div>
        </div>
      );
    }
}

export default Wheel;


// WEBPACK FOOTER //
// ./src/components/Wheel/index.tsx